const DEFAULT_PROPS = Object.freeze({
    chips: true,
    multiple: true,
    deletableChips: true,
    clearable: true,
    returnObject: false,
    noDataReload: true,
    withSelection: true,
    withInputField: true,
    isFormElement: true
})

export default DEFAULT_PROPS